<template>
  <div>
    <job-menu :job="job"></job-menu>

    <div class="my-10 px-4">
      <div class="flex justify-center items-center">
        <h1 class="text-3xl font-bold text-center w-full mb-5 md:mb-0 md:w-auto">
          {{ __('Create new notification for #:id', {id: job.id}) }}
        </h1>
      </div>

      <div class="bg-white px-4 py-10 shadow-md mt-10 overflow-x-auto">
        <div class="max-w-5xl mx-auto">

          <h2 class="text-3xl text-gray-800 mb-10">
            {{ __("Job finished") }}
          </h2>

          <textarea-input v-model="form.message"/>

          <div class="mt-10 flex">
            <button :disabled="!job.permissions.update" @click="storeJobCompleteRequest()" class="h-16 flex items-center justify-center text-2xl px-8 min-w-40 py-2 rounded text-white bg-coral-400 hover:bg-coral-300">
              {{ __("Send") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
  import Layout from '@/Shared/Layout';
  import TextareaInput from '@/Shared/TextareaInput';
  import JobMenu from "../Jobs/JobMenu";

  export default {
    layout: Layout,
    metaInfo() {
      return {
        title: this.__('Create new notification for #:id', {id: this.job.id}),
      }
    },
    props: {
      job: Object,
      message: String
    },
    components: {
      Layout,
      JobMenu,
      TextareaInput
    },
    data() {
      return {
        form: {
          message: this.message
        }
      }
    },
    methods: {
      storeJobCompleteRequest() {
        if (confirm(this.__("Confirm"))) {
          this.$inertia.post(this.route('jobCompleteRequests.store', {job: this.job.id}), {
            message: this.form.message
          });
        }
      }
    }
  }
</script>
